export default __webpack_public_path__ + "cc9ce389e9a4e0f518e3caeb7b60912d.svg";